import BaseRoute from 'seshy/routes/base';
import { service } from '@ember/service';

export default class AuthenticatedProjectsRoute extends BaseRoute {
  @service router;

  //redirect(){
  //this.router.transitionTo('authenticated.teams.show.projects.list');
  //}
}
